import { render, staticRenderFns } from "./HomeNewsWestudy.vue?vue&type=template&id=43747ee0&scoped=true&"
import script from "./HomeNewsWestudy.vue?vue&type=script&lang=js&"
export * from "./HomeNewsWestudy.vue?vue&type=script&lang=js&"
import style0 from "./HomeNewsWestudy.vue?vue&type=style&index=0&id=43747ee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43747ee0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataIterator } from 'vuetify/lib/components/VDataIterator';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VDataIterator,VImg,VRow,VSheet})
